// In-line destructuring syntax in an import statement when using ES Modules spec:
// 1) declaring a variable with the name in the { } - object desstructuring - so that if that name in the { } matches the name of a prop on the object it is pointing at (i.e. the namespace object on the file path we include after the from key word!) - we will succesfully hook into object literals short hand syntax in javascript 
// 2) and assign the value of that newly declared variable to be the value of the eponymously named property on the object it is pointing atimport { useAPI } from './useAPI.js';
import { useDashBaseAPI } from "./api/clients/useBaseAPI.js";

export const usePublicAPI = () => {
  const publics = useDashBaseAPI("/public");
  
  const getCoLogo = (pathParam) => {
    // Question 1: is actually not even axios making the request or maybe it is subseuently to the browser also?
    // Question 2: since its the browswer that makes requests to url likes this when url is value of an src attribute in an image tag or url is top level window naviagtion (i.e. in url bar!)
    return `${publics.defaults.baseURL}/image/${pathParam}`; 
  };
  
  return { 
    getCoLogo 
  };
};
